import { CONSTANTS } from '@shared/constants';

export const VENUE_ONE_MORE_QUESTION_ROUTES_PATHS_PARTIALS: {
  BASE_PATH: string;
} = {
  BASE_PATH: CONSTANTS.ROUTES.ONE_MORE_QUESTION,
};
